import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableToolbarContent } from '@carbon/react';
import Button from '@carbon/react/lib/components/Button/Button';

import { routes } from 'core/routing';
import { useHasAccess } from 'core/user/role';
import ActionButton from 'shared/components/ActionButton';
import useUpdateEffect from 'utils/hooks/useUpdateEffect';
import styles from 'theme/features/shared/project-list/project-list-table-toolbar.module.scss';

const ProjectListTableToolbar = ({ selectedRows, selectAll }) => {
  const navigate = useNavigate();

  const { hasEditAccess } = useHasAccess();

  const [errorMessage, setErrorMessage] = useState(null);

  const handleCompare = () => {
    if (selectedRows.length === 2) {
      navigate(routes.compareProjects(selectedRows[0].id, selectedRows[1].id));
    } else {
      setErrorMessage('Only 2 projects can be compared at a time.');
    }
  };

  const handleEdit = () => {
    if (selectedRows.length === 1) {
      navigate(routes.projectInputs(selectedRows[0].id));
    } else {
      setErrorMessage(`Only 1 project can be ${hasEditAccess() ? 'edited' : 'viewed'} at a time.`);
    }
  };

  const handleCancel = () => {
    if (selectedRows.length > 0) {
      selectAll(false);
    }

    setErrorMessage(null);
  };

  useUpdateEffect(() => setErrorMessage(null), [selectedRows.length]);

  return (
    <TableToolbarContent className={styles.actions}>
      {errorMessage && <div className={styles['actions__error']}>&nbsp; &nbsp;{errorMessage}</div>}
      <ActionButton onClick={handleEdit} size="sm">
        {hasEditAccess() ? 'Edit' : 'Inputs'}
      </ActionButton>
      <ActionButton onClick={handleCompare} size="sm">
        Compare
      </ActionButton>
      <Button size="sm" disabled={selectedRows.length === 0 && errorMessage === null} onClick={handleCancel}>
        Cancel
      </Button>
    </TableToolbarContent>
  );
};

export default ProjectListTableToolbar;
